import { EMR_APIS } from "@/api_framework/api_config";

import { IEMRSingleEMRDetailsResponse } from "@/api_framework/api_modals/EMRs";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";

import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";

import AxiosCurlirize from "axios-curlirize";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";
interface IAPIreturnProps {
  status: boolean;
  data: any;
}

AxiosCurlirize(axios, () => {});
export const useEMRDetailsAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (emrId: string) => {
      dispatch(
        setLoading({
          key: "isEMRDetailsFetchInProgress",
          status: true,
        }),
      );
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        const response: IAPIreturnProps = await axios
          .get(`${EMR_APIS?.GET_EMR_DETAILS_V2?.baseURL}`, {
            params: {
              
              emr_id: emrId,
            },
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IEMRSingleEMRDetailsResponse>) => {
            dispatch(
              setLoading({
                key: "isEMRDetailsFetchInProgress",
                status: false,
              }),
            );
            if (res.data.status === true && res.data) {
              return { status: true, data: res.data.data };
            } else {
              return { status: false, data: null };
            }
          })
          .catch((e: AxiosError) => {
            captureError(e);
            sendCurl(e.config["curlCommand"]);
            dispatch(
              setLoading({
                key: "isEMRDetailsFetchInProgress",
                status: true,
              }),
            );

            return { status: false, data: null };
          });
        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return execute;
};
